module.exports = __webpack_public_path__ + "711f616e5cfa692df1d2a463015cc5ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/bus.svg
// module id = 2652
// module chunks = 0